module.exports = __webpack_public_path__ + "img/edit_black_24dp.70f71896.svg";